module.exports = __webpack_public_path__ + "img/symbol_3.09ec1a51.png";